/*============================================================================
main.js
============================================================================ */
(function(window, $) {
  // メディアクエリの定義（ブレイクポイント: 768px）
  const mqSP = window.matchMedia('(max-width: 768px)');

  const fn = {

    pageScroll: function($trigger) {
      if (!$trigger || $trigger.length < 1) {
        return this;
      }

      $trigger.on('click', function(e) {
        e.preventDefault();

        const href = $(this).attr('href');
        let targetTop = 0;

        if (href && href !== '#' && href !== '#top') {
          const targetEl = document.querySelector(href);
          if (targetEl) {
            targetTop = targetEl.getBoundingClientRect().top + window.pageYOffset;
          }
        }

        // ブラウザ標準の滑らかなスクロール処理を使用
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });

      return this;
    },

    // Go to Top Button
    btnGoTop: function($trigger) {
      const $footer = $('.l-footer');

      if($trigger.length < 1 || $footer.length < 1) {
        return this;
      }

      const $win = $(window);
      let winHeight = $win.height();
      let scrollTop = $win.scrollTop();
      let footerPosTop = 0;
      let showFlg = false;
      let fixFlg = false;
      let ticking = false;

      // フッター位置や画面高さを再計算する関数
      function updateMetrics() {
        winHeight = $win.height();
        footerPosTop = $footer.offset().top;
      }

      // 初回読み込み時 & リサイズ時のみ要素位置を測定（スクロール時には計算しない）
      updateMetrics();
      $win.on('resize', updateMetrics);

      // 描画最適化を行ったスクロール処理
      function onScroll() {
        scrollTop = $win.scrollTop();

        // Show & Hide 判定
        if (scrollTop >= winHeight / 2 && !showFlg) {
          $trigger.stop().fadeIn(500);
          showFlg = true;
        } else if (scrollTop < winHeight / 2 && showFlg) {
          $trigger.stop().fadeOut(500);
          showFlg = false;
        }

        // Position Reset 判定（フッター手前で固定）
        const threshold = footerPosTop - winHeight;
        if (scrollTop >= threshold && !fixFlg) {
          $trigger.addClass('is-absolute');
          fixFlg = true;
        } else if (scrollTop < threshold && fixFlg) {
          $trigger.removeClass('is-absolute');
          fixFlg = false;
        }
      }

      // requestAnimationFrame でスクロール時の処理負荷を軽減
      $win.on('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            onScroll();
            ticking = false;
          });
          ticking = true;
        }
      });
    },

    // Swiper Slide
    swiperSlide: function($trigger) {
      if (!$trigger || $trigger.length < 1) {
        return this;
      }

      $trigger.each(function() {
        const $el = $(this);
        const el = this;

        // Default Option
        const defaultOptions = {
          loop: false,
          navigation: {
            nextEl: $el.find('.swiper-button-next')[0] || '.swiper-button-next',
            prevEl: $el.find('.swiper-button-prev')[0] || '.swiper-button-prev',
          },
          pagination: {
            el: $el.find('.swiper-pagination')[0] || '.swiper-pagination',
            clickable: true,
          },
        };

        // Set Class Option
        const customOptions = {};

        // Home - Banners
        if ($el.hasClass('js-swiper-home-banners')) {
          customOptions.breakpoints = {
            375: {
              slidesPerView: 1.3,
              spaceBetween: 17,
            },
          };
        }

        // Home - School Life
        if ($el.hasClass('js-swiper-home-life')) {
          customOptions.breakpoints = {
            375: {
              slidesPerView: 1.4,
              spaceBetween: 17,
            },
          };
        }

        // Sp Only Running
        if ($el.hasClass('is-sp-only')) {
          let swiperInstance = null;
          const mm = window.matchMedia('(max-width: 768px)');

          const handleSpOnly = function(e) {
            if (e.matches) {
              // is SP
              if (!swiperInstance) {
                swiperInstance = new Swiper(el, $.extend(true, {}, defaultOptions, customOptions));
              }
            } else {
              // is PC
              if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
              }
            }
          };

          // Init & listener
          mm.addEventListener('change', handleSpOnly);
          handleSpOnly(mm);

          return;
        }

        // Init
        const finalOptions = $.extend(true, {}, defaultOptions, customOptions);
        new Swiper(el, finalOptions);
      });

      return this;
    },

    // Tab Change
    tabChange: function($trigger) {
      if (!$trigger || $trigger.length < 1) {
        return this;
      }

      $trigger.each(function() {
        const $tabList = $(this); // .js-tabs
        const $tabs = $tabList.find('li');
        
        const $container = $tabList.closest('.home-news-tabs');
        const $targets = $container.find('.js-tabs-target > .home-news-tabs-contents-target');

        $tabs.find('a').on('click', function(e) {
          e.preventDefault();

          const $thisLink = $(this);
          const $parentLi = $thisLink.parent('li');

          if ($parentLi.hasClass('is-current')) {
            return;
          }

          const index = $tabs.index($parentLi);

          $tabs.removeClass('is-current');
          $parentLi.addClass('is-current');

          $targets.removeClass('is-current');
          $targets.eq(index).addClass('is-current');
        });
      });

      return this;
    },

    // Normal Toggle Menu
    toggleMenu: function($trigger) {
      if($trigger.length < 1) {
        return this;
      }
      $trigger.on("click", function() {
        $(this).toggleClass("is-open");
        $(this).next().slideToggle();
      });
    },

    // Drawer Menu
    drawerMenu: function($trigger) {
      const $target = $('#js-drawer');

      // Add Flag
      let state = false;

      $trigger.on('click', function(event) {
        event.stopPropagation();

        if(!state) {
          $target.addClass('is-open');
          state = true;
        } else {
          // 閉じる処理
          $target.removeClass('is-open');
          state = false;
        }
      });
    },

  };

  $(function() {
    // For All Device
    fn.pageScroll($('.js-scroll'));
    fn.btnGoTop($('.footer-gotop'));
    // fn.toggleMenu($('.list-toggle-a dt'));
    fn.drawerMenu($('.js-drawer-trigger'));
    fn.swiperSlide($('.swiper'));
    fn.tabChange($('.js-tabs'));
  });
})(typeof window !== 'undefined' ? window : this, jQuery);